// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__3Sthv","calendarButtons":"ClockData_calendarButtons__3O4mw"};